import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/img.png";
import {
  AiFillInstagram,
  AiFillMail,
  AiFillFacebook,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-description pt-0 text-center">
            <h2 style={{ fontSize: "2.6em" }}>
               <span className="purple"> OUR MISSON </span>
            </h2>
            <p className="home-about-body">
              At Youkish Tech, we understand that technology is the backbone of modern business. That's why we offer tailor-made solutions to meet the unique needs of each client. Our team of expert developers, designers, and project managers work together to ensure that every project is delivered with the highest quality, on time, and within budget.
            </p>
          </Col>
          <Col md={12} className="home-about-description text-center">
            <h2 style={{ fontSize: "2.6em" }}>
               <span className="purple"> OUR VISION </span>
            </h2>
            <p className="home-about-body">
            We pride ourselves on being a partner that listens, understands, and collaborates with our clients to deliver solutions that not only meet but exceed their expectations. From initial concept to final deployment, <b className="purple"> Youkish Tech</b> is committed to providing seamless, scalable, and future-ready solutions that help businesses grow and thrive in todayâ€™s competitive market.
            </p>
          </Col>
          <Col md={12} className="home-about-description text-center">
            <h2 style={{ fontSize: "2.6em" }}>
               <span className="purple"> Why Choose Us?</span>
            </h2>
            <p className="home-about-body">
                <b className="purple"> Expert Team: </b>
              We have a team of skilled professionals with years of experience in the tech industry, dedicated to delivering the best results for your projects.
               <br/>
               <br/>
                <b className="purple"> Tailor-Made Solutions: </b>
              At Youkish Tech, we deliver custom software and development solutions designed to meet your unique business needs, ensuring that our services are perfectly aligned with your goals.
               <br/>
               <br/>
                <b className="purple"> Collaboration: </b>
              We believe in close collaboration with our clients. By understanding your goals and challenges, we ensure that every project is a perfect fit with your vision and objectives.
              <br/>
              <br/>
              <b className="purple"> Future-Ready: </b>
              Our solutions are scalable and built to grow with your business, offering long-term success and adaptability in an ever-evolving digital landscape.
            </p>
          </Col>
          <Col md={12} className="home-about-description text-center">
            <h2 style={{ fontSize: "2.6em" }}>
               <span className="purple"> Let's Build Something Extraordinary</span>
            </h2>
            <p className="home-about-body">
            No matter the size or complexity of your project, <b className="purple"> Youkish Tech</b> is here to bring your ideas to life with cutting-edge technology and creative development strategies. Let's work together to build something extraordinary!            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social mt-5">
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="mailto:youkishtech@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
